import { Box, Modal, Typography } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
import Button from "@accredo/fe-shared/theme/components/Button.jsx";
import PropTypes from "prop-types";

const DeleteBookingModal = ({ open, onClose, onConfirm, isLoading }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Zuordnung entfernen
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Möchten Sie die Zuordnung wirklich entfernen?
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Dabei wird die Verbindung zum Schaden entfernt und die Zahlung bleibt
          unzugeordnet im System bestehen.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button onClick={onClose} variant="tertiary">
            Abbrechen
          </Button>
          <Button
            onClick={onConfirm}
            variant="primary"
            disabled={isLoading}
            startIcon={<RemoveCircle />}
          >
            {isLoading ? "Wird entfernt..." : "Entfernen"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

DeleteBookingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // bookingId is required if modal is open, otherwise can be null
  bookingId: PropTypes.number,
};

export { DeleteBookingModal };
